export default function normalizeReportFinanceCommisionTmHotelReconciliation(data) {
    const feesConstants = {
        ORDER_PROCESSING: 'ORDER_PROCESSING',
        TM_PROCESSING: 'TM_PROCESSING',
        INSURANCE_BONDING: 'INSURANCE_BONDING',
        BREAKAGE_BONDING: 'BREAKAGE_BONDING',
        GST_PROCESSING: 'GST_PROCESSING',
    };

    const taxesConstants = {
        INCLUDED: 'INCLUDED',
        EXCLUDED: 'EXCLUDED',
        CITY: 'CITY',
        COUNTY: 'COUNTY',
        STATE: 'STATE',
    };

    const commissionConstants = {
        PROMOTER: 'PROMOTER',
        DATA_PROVIDER: 'DATA_PROVIDER',
        CLIENT: 'CLIENT',
        GST: 'GST',
    };

    function feeTypeAmount(fees, feeType) {
        let result = fees.find((fee) => fee.type === feeType);

        return result ? result.amount : 0;
    }

    function taxTypeAmount(taxes, taxType) {
        let result = taxes.find((tax) => tax.type === taxType);

        return result ? result.amount : 0;
    }

    function commissionTypeAmount(commissions, commissionType) {
        let result = commissions.find((commission) => commission.partnerType === commissionType);

        return result ? result.amount : undefined;
    }

    function promoter(commissions, commissionType) {
        let result = commissions.find((commission) => commission.partnerType === commissionType);

        return result ? result.partnerName : undefined;
    }

    const { hotelBookingNumber, hotelName, address, latitude, longitude, roomType, supplier, cancellationPolicies, stayRange, roomCount } = data.hotel;
    
    const hotelData = {
        hotelBookingNumber: hotelBookingNumber,
        hotelName: hotelName,
        hotelState: address?.stateCode || null,
        hotelCity: address?.cityName || null,
        hotelCountry: address?.countryCode || null,
        hotelZipCode: address?.zipCode || null,
        hotelLatitude: latitude,
        hotelLongitude: longitude,
        roomType: roomType || '',
        bookingStatus: data.status || '',
        hotelSupplier: supplier || '',
        cancellationPolicies: cancellationPolicies || '',
        checkIn: stayRange?.checkin || '',
        checkOut: stayRange?.checkout || '',
        lengthOfStay: stayRange?.lengthOfStay || '',
        roomCount: roomCount,
    }


    return {
        orderNumber: data.orderNumber,
        id: data.id,
        hotelBookingNumber: data.hotelBookingNumber || '',
        packageId: data.packageInfo.id,
        createdLocalDateTime: data.createdLocalDateTime,
        createdUTCDateTime: data.createdDateTime,
        currency: data.currency,
        eventSystem: data.event.system,
        eventCode: data.event.code,
        eventPartnerProductId: data.event.partnerProductId,
        eventName: data.event.name,
        eventStartDate: data.event.startDate,
        promoter: promoter(data.commissions, 'PROMOTER'),
        offerName: data.event.offerName,
        venueName: data.event.venueName,
        venueState: data.event.venueState,
        venueCity: data.event.venueCity,
        venueZipCode: data.event.venueZipCode,
        eventTicketsNumber: data.event.ticketsNumber,
        totalGrossPackageValue: data.amounts.totalGrossPackageValue,
        serviceCharges: data.amounts.serviceCharges,
        facilityFees: data.amounts.facilityFees,
        grossTotalValue: data.amounts.grossTotalValue,
        netRevenue: data.amounts.netRevenue,
        ownedToGst: data.amounts.ownedToGst,
        totalSettlement: data.amounts.totalSettlement,
        taxes: data.amounts.taxes || '',
        packageTax: data.amounts.packageTax,
        totalHotelCost: data.amounts.totalHotelCost,
        upliftWithTMFees: data.amounts.upliftWithTMFees,
        tmProcessing: feeTypeAmount(data.fees, feesConstants.TM_PROCESSING),
        insuranceBonding: feeTypeAmount(data.fees, feesConstants.INSURANCE_BONDING),
        breakageBonding: feeTypeAmount(data.fees, feesConstants.BREAKAGE_BONDING),
        gstProcessing: feeTypeAmount(data.fees, feesConstants.GST_PROCESSING),
        promoterCommission: commissionTypeAmount(data.commissions, commissionConstants.PROMOTER),
        tmCommission: commissionTypeAmount(data.commissions, commissionConstants.CLIENT),
        tmPreSplitCommission: commissionTypeAmount(
            data.commissions,
            commissionConstants.DATA_PROVIDER
        ),
        gstCommission: commissionTypeAmount(data.commissions, commissionConstants.GST),
        supplierIncludedTax: taxTypeAmount(data.taxes, taxesConstants.INCLUDED),
        supplierExcludedTax: taxTypeAmount(data.taxes, taxesConstants.EXCLUDED),
        packageStateTax: taxTypeAmount(data.taxes, taxesConstants.STATE),
        packageCityTax: taxTypeAmount(data.taxes, taxesConstants.CITY),
        packageCountyTax: taxTypeAmount(data.taxes, taxesConstants.COUNTY),
        ...hotelData
    };
}
